import { Defaults, SaveTrees } from "@timesheets/constants-common";

import { LogoType } from "@gemma/typescript-types";
import { WebApplicationConstants } from "@/setup/WebApplicationConstants";
import { getLogoPathFromType as webGetLogoPathFromType } from "@gemma/web-common";

export function getLogoPathFromType(logoType: LogoType, canonicalName: string = WebApplicationConstants.currentTenant, { original = false, email = false }: { original?: boolean; email?: boolean } = {}) {
  const logoPath = webGetLogoPathFromType(logoType, canonicalName, SaveTrees.ReservedNames, Defaults.LogoName, { original, email });

  return logoPath;
}
